const Template = {
  Act: "",
  Socials: ["", ""],
  Time: "",
};

export const StageSchedule = {
  Schedule: [
    {
      Act: "Camille & Robin",
      Socials: ["https://www.instagram.com/orwin_camille.music/"],
      Time: "15:45PM-16:30PM",
    },
    {
      Act: "Finnbar & Scott",
      Socials: [""],
      Time: "16:30PM-17:15PM",
    },
    {
      Act: "PH7",
      Socials: ["https://www.instagram.com/ph7band/"],
      Time: "17:15PM-18:00PM",
    },
    {
      Act: "Gents and Ginger",
      Socials: ["https://www.instagram.com/gentsandginger/"],
      Time: "18:00PM-19:00PM",
    },
    {
      Act: "The Strand",
      Socials: ["https://www.instagram.com/thestrand.band/"],
      Time: "19:00PM-20:00PM",
    },
    {
      Act: "Floral Pattern",
      Socials: ["https://www.instagram.com/flor.alpattern/"],
      Time: "20:00PM-21:00PM",
    },
    {
      Act: "Everything After Midnight",
      Socials: ["https://www.instagram.com/everythingaftermidnight/"],
      Time: "21:00PM-22:00PM",
    },
  ],
};
